import { render, staticRenderFns } from "./ProjectLiveSend.vue?vue&type=template&id=708d760e&scoped=true&"
import script from "./ProjectLiveSend.vue?vue&type=script&lang=ts&"
export * from "./ProjectLiveSend.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLiveSend.vue?vue&type=style&index=0&id=708d760e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d760e",
  null
  
)

export default component.exports